// frontend/src/GothamPosProducts/apiClient.js — thin wrapper around authenticatedFetch for /api/gotham-pos-products (same shape as ClubSalesHistory/apiClient.js).
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/gotham-pos-products';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const get = (path) => authenticatedFetch(`${BASE}${path}`).then(jsonOrThrow);
const post = (path, body) => authenticatedFetch(`${BASE}${path}`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
}).then(jsonOrThrow);

export const gppApi = {
  products: () => get('/products'),
  setPos: (productIds, onPos) => post('/pos', { product_ids: productIds, on_pos: onPos }),
  transfer: (productId, moves) => post('/transfer', { product_id: productId, moves }),
};
